import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
} from "@mui/material"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { DetailTable } from "@/components/Tables/DetailTable"
import { columns } from "@/pages/products/Columns"

const SupplierDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["product-variant-detail", id], `product-variant/${id}`)

  if (isLoading) {
    return <div>Loading...</div>
  }

  const variant = response?.data
  console.log(variant)

  return (
    <div>
      <div className="breadcrumb-card">
        <h5>Product Variant Details</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/product-variants">Product Variants</Link>
          </li>
          <li>{variant.code}</li>
        </ul>
      </div>
      {variant ? (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 xxl:tw-grid-cols-5 tw-gap-6">
          <Box className="bg-white border-0 rounded-3 p-3 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <LetterAvatar name={variant.name} />
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <span>Code:</span>
              <span className="text-secondary ms-1">{variant.code}</span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span>Tags:</span>
              <span className="text-secondary ms-1">
                {Array.isArray(variant.tags) ? (
                  variant.tags?.map((tag, index) => (
                    <TagsBadge key={tag.id || index} name={tag?.name} /> // Ensure the `name` prop is a string
                  ))
                ) : (
                  <TagsBadge name={variant.tags?.name} /> // Handle a single object if needed
                )}
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span>Item Stock:</span>
              <span className="text-secondary ms-1">{variant.stock}</span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span>Supplier:</span>
              <span className="text-secondary ms-1">
                {variant.supplier?.name}
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span>Created By:</span>
              <span className="text-secondary ms-1">
                {variant.createdBy?.name}
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span>Updated By:</span>
              <span className="text-secondary ms-1">
                {variant?.updatedBy?.name}
              </span>
            </div>
          </Box>
          <div className="tw-bg-white tw-rounded-xl tw-p-4 tw-shadow lg:tw-col-span-3 xxl:tw-col-span-4">
            <p className="tw-text-base tw-font-semibold tw-mb-4">Products</p>
            <CrudProvider>
              <ProductList variant={variant} isLoading={isLoading} />
            </CrudProvider>
          </div>
        </div>
      ) : (
        <div>No User data found.</div>
      )}
    </div>
  )
}
function ProductList({ variant, isLoading }) {
  return (
    <>
      <DetailTable
        columns={columns}
        data={variant.products}
        isLoading={isLoading}
      />
    </>
  )
}

function TagsBadge({ name }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        marginRight: "8px", // Add some space between badges
      }}
    >
      <div className={`trezo-badge`}>{name}</div>
    </Box>
  )
}

export default SupplierDetails
